import { useEffect, useState } from 'react'

/**
 * Is this a phone or tablet? (D-108)
 *
 * Only used to choose wording and to offer the `otpauth://` deep link: a phone
 * cannot scan a QR code shown on its own screen, so it gets a different pairing path
 * than a desk. Chrome on a laptop with a touchscreen reports a coarse pointer too —
 * which is harmless, because it can still use the same buttons or scan the code.
 */
export function isTouchDevice(): boolean {
  if (typeof window === 'undefined') return false
  try {
    if (typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches) {
      return true
    }
  } catch {
    // Older embedded browsers can throw on an unknown media feature.
  }
  return (typeof navigator !== 'undefined' ? navigator.maxTouchPoints : 0) > 0
}

/**
 * `isTouchDevice()` after mount.
 *
 * Deliberately false during server rendering so the markup hydrates identically;
 * the phone-specific affordances appear on the first client effect, before anyone
 * can interact with the screen.
 */
export function useIsTouch(): boolean {
  const [touch, setTouch] = useState(false)
  useEffect(() => {
    setTouch(isTouchDevice())
  }, [])
  return touch
}
